export const FF_ENABLE_BRANCH_SELECTION_DESIGN = 'FF_ENABLE_BRANCH_SELECTION_DESIGN';
